module.exports = __webpack_public_path__ + "assets/chat-f959f2.svg";